export default {
  url: 'https://www.bluemonday.se'
}